import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { concat, of, Subject, Subscription } from 'rxjs';
import { catchError, map, switchMap, startWith } from 'rxjs/operators';
import { BadgeService } from '../services/badge.service';
import { badgeScore, BadgeCollection, orderedBadges } from '../models/badge.models';

@Component({ selector: 'app-badge-collection', templateUrl: './badge-collection.component.html', styleUrls: ['./badge-collection.component.scss'] })
export class BadgeCollectionComponent implements OnChanges, OnDestroy {
    @Input() challengeId: number;
    @Input() enrollmentId: number;
    @Input() teamId: number;
    @Input() title = 'Badges and awards';
    category: 'all' | 'leaderboard' | 'achievements' = 'all';
    achievements(data: BadgeCollection) { return (data.EarnedAwards || []).filter(award => !award.FinalMedal); }
    leaderboard(data: BadgeCollection) { return orderedBadges(data.Badges || []); }
    progress(data: BadgeCollection) { return (data.Progress || []).filter(item => !item.Unavailable); }
    private reload = new Subject<void>();
    private changes: Subscription;
    readonly score = badgeScore;
    readonly view$ = this.reload.pipe(startWith(null), switchMap(() => {
        const empty: BadgeCollection = { State: 'pending', Badges: [] };
        if (!this.challengeId || (!this.enrollmentId && !this.teamId)) { return of({loading: false, error: '', data: empty}); }
        return concat(of({loading: true, error: '', data: empty}), this.loadCollection().pipe(
            map(data => ({loading: false, error: '', data})), catchError(() => of({loading: false, error: 'Unable to load badges.', data: empty}))));
    }));
    constructor(protected service: BadgeService) { this.changes = service.changed$.subscribe(() => this.reload.next()); }
    protected loadCollection() { return this.service.collection(this.challengeId, this.enrollmentId, this.teamId); }
    ngOnChanges(): void { this.category = 'all'; this.reload.next(); }
    refresh(): void { this.service.expireCollections?.(); this.reload.next(); }
    trackBadge(index: number, badge: { ChallengeBadgeRuleId: number }): number { return badge.ChallengeBadgeRuleId; }
    ngOnDestroy(): void { this.changes.unsubscribe(); this.reload.complete(); }
}
